import { Link } from "react-router-dom";
import { useMall } from "@/context/MallContext";

/** The hallway's own ticker — nobody's shop. Paper strip, ink type. */
const MALL = [
    "THE 13THAV SHOP DIRECTORY",
    "STARTER $9 · STOREFRONT $29 · PRO SHOP $79 · YOUR OWN PRIVATE SITE $199",
    "CLASSIFIEDS · POST A FREE AD",
    "WHOLESALE CLUB · BRONZE · SILVER · GOLD",
    "EVERY SHOP PRINTS ITS OWN WORK",
];

const SHOP = [
    "WHITE TEES — PRINTING TODAY · ORDER BY 2PM",
    "DTF GANG SHEETS · 15.5\" WIDE · ANY LENGTH",
    "SAME-DAY PICKUP · 24-HR LOCKER",
    "STANDARD ORDER IN UNDER 4 CLICKS",
    "SIGNS · BANNERS · DECALS · READY IN 3–5 DAYS",
];

export default function Ticker() {
    const { store } = useMall();
    const lines = store ? SHOP : MALL;
    const row = [...lines, ...lines];
    return (
        <Link to={store ? "/shirts" : "/directory"} className="group block overflow-hidden border-b border-black/10 bg-[#FAFAFA]" data-testid="ticker">
            <div className="flex w-max animate-marquee group-hover:[animation-play-state:paused]" data-testid="ticker-bar">
                {row.map((t, i) => (
                    <span key={i} className="whitespace-nowrap px-6 py-2 font-mono text-xs font-bold uppercase tracking-widest text-zinc-900">
                        {t} <span className="px-3 text-zinc-400">/</span>
                    </span>
                ))}
            </div>
        </Link>
    );
}
